import { apiFetch } from "@core/http";
import type { Promotion, PromotionInput } from "@core/types";
import type { components } from "@core/types/openapi";

export type { Promotion, PromotionInput } from "@core/types";

type Warning = components["schemas"]["Warning"];

const base = "/v1/portal/content/promotions";

// SPEC-206 §3/§4: el listado completo de gestión, en el orden manual, con el
// aviso agregado de cantidad (`TOO_MANY_PROMOTIONS`) cuando corresponde.
export interface PromotionListResponse {
  readonly items: Promotion[];
  readonly warnings?: Warning[];
}

export const listPromotions = () => apiFetch<PromotionListResponse>(base);

export const createPromotion = (input: PromotionInput) =>
  apiFetch<Promotion>(base, { method: "POST", body: input });

export const editPromotion = (id: string, input: PromotionInput) =>
  apiFetch<Promotion>(`${base}/${encodeURIComponent(id)}`, {
    method: "PUT",
    body: input,
  });

// SPEC-206 §9/PA-019-F: DELETE inactiva, nunca borra de forma permanente.
// Reactivar es un PUT con `active: true` (`editPromotion`), no un verbo
// propio.
export const inactivatePromotion = (id: string) =>
  apiFetch<void>(`${base}/${encodeURIComponent(id)}`, { method: "DELETE" });

export type PromotionMoveDirection = "up" | "down";

export interface PromotionMoveResponse {
  readonly items: Promotion[];
}

// SPEC-206 §4/PA-019-G: flechas ↑/↓ del listado. En un extremo (no hay
// vecino en esa dirección) el servidor responde 200 sin cambios — el
// portal ya deshabilita esa flecha antes de llegar a llamar esto.
export const movePromotion = (id: string, direction: PromotionMoveDirection) =>
  apiFetch<PromotionMoveResponse>(`${base}/${encodeURIComponent(id)}/move`, {
    method: "POST",
    body: { direction },
  });
